import type { CompetitionTeamDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getCompetitionTeamDetails(competitionId: string, teamId: string): Promise<CompetitionTeamDetailed> {
  return requestApiJsonOrThrow<CompetitionTeamDetailed>(
    `admin/competitions/${competitionId}/competition-teams/${teamId}`
  )
}

export const competitionTeamDetailsQuery = (competitionId: string, teamId: string) => ({
  queryKey: ['competition', competitionId, 'team', teamId],
  queryFn: () => getCompetitionTeamDetails(competitionId, teamId),
})
